<error-error-content 
  image="assets/img/images/error-images/image3.png"
  errorType="TEMPORARILY_UNAVAILABLE"
  copy="ERROR_503"></error-error-content>

